import { useCallback, useState } from 'react'

import { ApiError } from '@api'
import { useUnit } from 'effector-react'
import { useNavigate } from 'react-router'

import { addScriptFx } from '@/models/scripts/scripts.ts'
import type { EditorForm } from '@/modules/scripts/components/ScriptEditView'
import { ScriptEditView } from '@/modules/scripts/components/ScriptEditView'
import { AppRoutes } from '@/utils/constants'
import { useCreatorUrl } from '@/utils/creators.ts'

export const CreateScriptPage = () => {
  const navigate = useNavigate()
  const [error, setError] = useState<Nullable<ApiError>>(null)
  const isLoading = useUnit(addScriptFx.pending)

  const listUrl = useCreatorUrl(AppRoutes.Creator.Settings.Scripts.List)

  const handleBack = useCallback(() => navigate(listUrl), [navigate, listUrl])

  const handleSave = useCallback(
    async (state: EditorForm) => {
      if (state.category == null) {
        return
      }
      try {
        await addScriptFx({
          name: state.title ?? '',
          category: state.category,
          message: {
            text: state.text,
            enableFallbackVariable: state.enableFallbackVariable,
            fallbackVariable: state.fallbackVariable!,
            fallback: state.fallback!,
            // @ts-ignore
            medias: state.medias!,
            price: state.price!,
          },
        })
        navigate(-1)
      } catch (error) {
        setError(error as ApiError)
      }
    },
    [navigate],
  )

  return (
    <ScriptEditView
      mode="create"
      onBack={handleBack}
      onSave={handleSave}
      isSaving={isLoading}
      error={error}
    />
  )
}
